/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import APP_CONST from "../../../shared/constants";
import MilestoneViewDialog from "./MilestoneViewDialog";
import PlaceholderComponent from "../../../containers/ArchiveDashboard/PlaceholderComponent";
import {
  ViedocButtonElement,
  ViedocCheckboxElement,
} from "../../../../secure/elements/ViedocReactElements";
import ViewArtifactDialog from "./ViewArtifactDialog";

import * as UtilsHelper from "../../../../../utils/utilsHelper";
import * as templateActions from "../../../../store/actions/templateActions";
import * as loaderActions from "../../../../store/actions/loaderActions";
import {clearDocumentList} from "../../../../store/actions/zoneActions"
import Loader from "../../shared/Loader/Loader";
import EditArtifactPopUp from "./EditArtifactPopUp";
import AddArtifactPopUp from "./AddArtifactPopUp";
import EditZoneSection from "./EditZoneSection";
import AddStructureElementPopUp from "./AddStructureElementPopUp";
import _ from "underscore";
import StructureChanges from "./StructureChanges/StructureChanges";
import EditStructure from "./EditStructure/EditStructure";

const TmfStructure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    tmfStructureData,
    zoneData,
    milestoneCount,
    fullDateTimePattern,
    dateLocale,
    isLoading,
    instantiateLoading,
    ischangefound,
    isChangeLoading,
    isEditLoading,
    isDeleteLoading,
    isExporting,
    templateInitializing,
    structureversion,
    structurename,
    isEtmfLocked,
    settings,
    selectedLoading,
    isCountLoading,
    isMilestoneChanged,
  } = useSelector((store) => store.template);
  const { userList, isReadOnlyAdmin, isZoneLoading, apiInitConfigObj } = useSelector(
    (store) => store.zone
  );
  const { originaltemplateid, status, templatename } = tmfStructureData;

  const noTemplates = zoneData.length === 0;

  const [viewMilestone, setViewMilestone] = useState(false);
  const [isEditArtifactVisible, setIsEditArtifactVisible] = useState(false);
  const [isEditZoneSectionVisible, setIsEditZoneSectionVisible] =
    useState(false);
  const [isAddArtifactVisible, setIsAddArtifactVisible] = useState(false);
  const [isNewStructureElementVisible, setIsNewStructureElementVisible] =
    useState(false);
  const [viewArtifactObj, setViewArtifactObj] = useState(false);

  const [artifactDetails, setArtifactDetails] = useState();
  const [sections, setSections] = useState("");
  const [sectionId, setSectionId] = useState();
  const [artifacts, setArtifacts] = useState("");
  const [artifactId, setArtifactId] = useState();
  const [isApplyRevertVisible, setApplyRevertVisible] = useState(false);
  const [fromApplyOrRevert, setFromApplyOrRevert] = useState();
  const [isStructureEditVisible, setIsStructureEditVisible] = useState(false);
  const isAdminReadOnly = !isReadOnlyAdmin && !isEtmfLocked;
  const [isChecked, setIsChecked] = useState(
    status === APP_CONST.ADMIN_TEMPLATE_STATUS[2]
  );

  const [zoneSectionView, setZoneSectionView] = useState(
    isChecked && isAdminReadOnly ? "edit" : "view"
  );

  const HEADER_COUNT_CONTENT = [
    {
      id: 1,
      count: tmfStructureData.zonecount,
      label:
        tmfStructureData.zonecount > 1
          ? t("ADMIN.TEXT_ZONES")
          : t("ADMIN.TEXT_ZONE"),
    },
    {
      id: 2,
      count: tmfStructureData.sectioncount,
      label:
        tmfStructureData.sectioncount > 1
          ? t("ADMIN.TEXT_SECTIONS")
          : t("ADMIN.TEXT_SECTION"),
    },
    {
      id: 3,
      count: tmfStructureData.artifactcount,
      label:
        tmfStructureData.artifactcount > 1
          ? t("ADMIN.TEXT_ARTIFACTS")
          : t("ADMIN.TEXT_ARTIFACT"),
    },
  ];

  useEffect(()=>{
    let relVer = (apiInitConfigObj.releaseversion !== undefined) ? `?i=`+apiInitConfigObj.releaseversion : "";
    navigate("/tmf-structure" + relVer)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[apiInitConfigObj.releaseversion])

  useEffect(() => {
    dispatch(clearDocumentList());
    dispatch(templateActions.getTMFStructureData("onload"));
    dispatch(templateActions.getTMFStructureChanges());
    dispatch(templateActions.getMilestoneInfoList());
    dispatch(templateActions.getMileStoneList());
    dispatch(templateActions.getMilestoneGroup());

    return () => dispatch(loaderActions.hideError());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsChecked(status === APP_CONST.ADMIN_TEMPLATE_STATUS[2]);
  }, [status]);

  if (noTemplates && !selectedLoading && !isLoading) {
    return (
      <PlaceholderComponent
        title={t("ADMIN.TEMPLATES_NOTEMPLATE")}
        subTitle={
          <>
            {" "}
            {t("ADMIN.TEMPLATES_GOTO")}{" "}
            <a
              onClick={() => navigate("/templates")}
              className="light-grey underline cursor-pointer"
              title="Templates"
            >
              {t("ADMIN.ADMINTAB_TEMPLATES")}
            </a>{" "}
            {t("ADMIN.TEMPLATES_SELECTTEMPLATE")}
          </>
        }
      />
    );
  }

  const handleInstantiateTemplate = () => {
    const requestPayload = { templateId: originaltemplateid };
    dispatch(templateActions.instantiateTemplate(requestPayload));
  };

  const maintenanceHandler = (e) => {
    const mode = status === APP_CONST.ADMIN_TEMPLATE_STATUS[2] ? "off" : "on";
    setIsChecked((prevState) => !prevState);
    dispatch(
      templateActions.maintenanceOnOff(
        mode,
        status,
        APP_CONST.ADMIN_TEMPLATE_STATUS[2]
      )
    );
  };

  const structureEditHandler = () => {
    setIsStructureEditVisible(true);
    dispatch(templateActions.getTmfStructDetails());
  };

  const getStatusText = (statusText) => {
    switch (statusText) {
      case "Maintenance mode switched on ":
        return t("ADMIN.TEXT_MAINTAINANCEMODEON");

      case "Last modified ":
        return t("ADMIN.TEXT_LASTMODIFIED");

      case "Template selected ":
        return t("ADMIN.TEXT_STRUCTURESELECTED");

      case "Structure instantiated ":
        return t("ADMIN.TEXT_STRUCTUREINSTANTIATED");

      default:
        return statusText;
    }
  };

  const renderTemplateDetails = () => {
    return (
      <>
        <div className="d-flex align-center gap-10">
          <p
            className={`lh1_5 f21 ff-vmg ${
              ischangefound && structurename !== templatename && isChecked
                ? "edit-color "
                : "sem-pri-color"
            }`}
          >
            {isChecked
              ? structureversion ||
                UtilsHelper.fileExtensionRemoval(templatename || "")
              : UtilsHelper.fileExtensionRemoval(templatename || "")}
          </p>
          {isChecked &&
            isAdminReadOnly &&
            !(isEditLoading || isChangeLoading || instantiateLoading || isLoading) && (
              <div className="structure-edit cursor-pointer">
                <viedoc-icon
                  name="mode"
                  title={t("ADMIN.TEXT_EDIT")}
                  onClick={structureEditHandler}
                />
              </div>
            )}
        </div>
        {isEditLoading || instantiateLoading ? (
          <viedoc-spinner size="small" class="export-spinner" />
        ) : (
          <p className="lh1_2 f16 ff-mg">
            {getStatusText(tmfStructureData.displaystatustext)}{" "}
            {fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  tmfStructureData.displaydate,
                  dateLocale
                )
              : UtilsHelper.localDateConversion(tmfStructureData.displaydate)}
            {" " + t("TMF.TEXT_BY") + " "}
            {UtilsHelper.findUserName(userList, tmfStructureData.displayuser)}
          </p>
        )}
      </>
    );
  };

  const renderInstantiationBlock = () => {
    return (
      <section className="mrl-30 mt-15">
        <div className="structure-box">
          <div className="structure-generate-file mr-15">
            <viedoc-icon name="folder_unselected" />
          </div>
          <div className="structure-generate-content">
            {renderTemplateDetails()}
          </div>
          {isAdminReadOnly && (
            <div className="structure-generate-button d-flex align-center">
              <a
                onClick={() => navigate("/templates")}
                className="f14 pr-15 cursor-pointer"
                title={t("ADMIN.ADMINTAB_CHANGETEMPLATES")}
              >
                {t("ADMIN.ADMINTAB_CHANGETEMPLATES")}
              </a>
              <ViedocButtonElement
                variant="info"
                size="medium"
                onClick={() => handleInstantiateTemplate()}
                title={!instantiateLoading ? t("ADMIN.ADMINTAB_INSTANTIATE") : ""}
              >
                {instantiateLoading ? (
                  <viedoc-spinner></viedoc-spinner>
                ) : (
                  t("ADMIN.ADMINTAB_INSTANTIATE")
                )}
              </ViedocButtonElement>
            </div>
          )}
        </div>
      </section>
    );
  };

  const handleStructureChanges = (from) => {
    dispatch(templateActions.getTMFStructureChanges());
    setApplyRevertVisible(true);
    from === "apply" ? setFromApplyOrRevert(true) : setFromApplyOrRevert(false);
  };

  const RenderChangesBlock = () => {
    return ischangefound ? (
      <div className="changes-block">
        <viedoc-icon name="info" />
        <p>{t("ADMIN.TOAST_CHANGESMAINTENANCE")}</p>
        <ViedocButtonElement
          size="small"
          variant="success"
          onClick={() => handleStructureChanges("apply")}
          title={t("TMF.BUTTON_APPLYALLCHANGES")}
        >
          {t("TMF.BUTTON_APPLYALLCHANGES")}
        </ViedocButtonElement>
        <ViedocButtonElement
          size="small"
          variant="secondary"
          onClick={() => handleStructureChanges()}
          title={t("TMF.BUTTON_REVERTALLCHANGES")}
        >
          {t("TMF.BUTTON_REVERTALLCHANGES")}
        </ViedocButtonElement>
      </div>
    ) : (
      <p>{t("ADMIN.TOAST_NOCHANGESMAINTENANCE")}</p>
    );
  };

  const renderMaintenanceBlock = () => {
    return (
      <section className="mrl-30 mt-15">
        <div
          className={
            isChecked && isAdminReadOnly
              ? "structure-box maintenance-on"
              : "structure-box"
          }
        >
          <div className="structure-generate-file mr-15">
            <viedoc-icon name="folder_unselected" />
          </div>
          <div className="structure-generate-content">
            {renderTemplateDetails()}
          </div>
          {isAdminReadOnly && (
            <div className="structure-generate-button d-flex align-center">
              <p className="f21 pr-15 ff-vmg sem-pri-color">
                {t("ADMIN.ADMINTAB_MAINTENANCE")}
              </p>

              <ViedocCheckboxElement
                checked={isChecked}
                display-mode="toggle"
                disabled={instantiateLoading || isCountLoading}
                class="cursor-pointer"
                title={`${t("ADMIN.ADMINTAB_MAINTENANCE")} ${
                  isChecked ? t("TMF.TEXT_ON") : t("TMF.TEXT_OFF")
                }`}
                onChange={(e) => maintenanceHandler(e)}
              />
            </div>
          )}
        </div>
        {isChecked && isAdminReadOnly && (
          <div className="maintenance-on-block">
            {isChangeLoading || isEditLoading ? (
              <viedoc-spinner size="small" />
            ) : (
              <RenderChangesBlock />
            )}
          </div>
        )}
      </section>
    );
  };

  const renderMilestonesBadge = () => {
    return (
      <section className="mrl-30 milestone-generate mt-15">
        <div className="structure-box">
          <div className="structure-generate-file mr-15">{milestoneCount}</div>
          <div className="structure-generate-content">
            <p
              className={`sem-pri-color lh1_5 f21 ff-vmg cell ${
                isMilestoneChanged &&
                !isReadOnlyAdmin &&
                !isEtmfLocked &&
                status === APP_CONST.ADMIN_TEMPLATE_STATUS[2]
                  ? "edit-color"
                  : ""
              }`}
            >
              {t("ADMIN.ADMINTAB_MILESTONE")}{" "}
            </p>
          </div>
          <div className="structure-generate-button align-self-center">
            {!(isEditLoading || isChangeLoading) && (
              <ViedocButtonElement
                size="small"
                variant="info"
                title={
                  status === APP_CONST.ADMIN_TEMPLATE_STATUS[2] &&
                  isAdminReadOnly
                    ? t("ADMIN.TEXT_EDIT")
                    : t("ADMIN.TEXT_VIEW")
                }
                onClick={() => viewMilestoneHandler()}
              >
                {status === APP_CONST.ADMIN_TEMPLATE_STATUS[2] &&
                isAdminReadOnly
                  ? t("ADMIN.TEXT_EDIT")
                  : t("ADMIN.TEXT_VIEW")}
              </ViedocButtonElement>
            )}
          </div>
        </div>
      </section>
    );
  };

  const renderTMFStuctureHeader = () => {
    return (
      <header className="d-flex align-center p20 bb-1 bt-1 mt-15">
        <div className="flexgr-8 f16 sem-pri-color">
          {t("ADMIN.ADMINTAB_TMFSTRUCTURE")}
        </div>
        <div className="d-flex align-center f14 gray-60 fw-400">
          {HEADER_COUNT_CONTENT.map((item) => (
            <p key={item.id}>
              {item.id !== 1 ? "-" : null} {item.count} {item.label}&nbsp;
            </p>
          ))}
        </div>
      </header>
    );
  };

  const selectIcons = (zone) => {
    switch (zone) {
      case "zones":
        return "zones";
      case "section":
        return "sections";
      case "artifact":
        return "artifacts";
      default:
        return "folder";
    }
  };

  const levelClick = (item, level) => {
    if (item.origid === sectionId) {
      setSections("");
      setSectionId("");
      return;
    } else if (item.origid === artifactId) {
      setArtifacts("");
      setArtifactId("");
      return;
    }
    switch (level) {
      case "zones":
        setArtifactDetails({
          ...artifactDetails,
          zoneName: item.name,
          zoneId: item.origid,
        });
        setSections(item.name);
        setSectionId(item.origid);
        return;
      case "section":
        setArtifactDetails({
          ...artifactDetails,
          sectionName: item.name,
          sectionId: item.origid,
        });
        setArtifacts(item.name);
        setArtifactId(item.origid);
        return;
      default:
        return;
    }
  };

  const editArtifactHandler = (event, artifactInfo, location) => {
    event.stopPropagation();
    setArtifactDetails({
      ...artifactDetails,
      ...artifactInfo,
      location: location,
    });
    if (location === "artifact") {
      dispatch(
        templateActions.getViewZoneSectionArtifact(
          "edit",
          location,
          artifactInfo.origid
        )
      );
      dispatch(templateActions.getMileStoneList());
      dispatch(templateActions.getDatingConventionList());
      setIsEditArtifactVisible(true);
    } else {
      setZoneSectionView(isChecked && isAdminReadOnly ? "edit" : "view");
      setIsEditZoneSectionVisible(true);
    }
  };

  const addArtifactHandler = (event, artifactInfo, location) => {
    event.stopPropagation();
    let zoneId, sectionId, zoneName, sectionName;
    if (location === "zones") {
      zoneId = artifactInfo.origid;
      sectionId = "";
      zoneName = zoneId + " " + artifactInfo.name;
      sectionName = "";
    } else if (location === "section") {
      zoneId = artifactInfo.origid.split(".")[0];
      let selectedZone = zoneData.filter((zone) => zone.origid === zoneId)[0]
        .name;
      sectionId = artifactInfo.origid;
      zoneName = zoneId + " " + selectedZone;
      sectionName = sectionId + " " + artifactInfo.name;
    }
    setArtifactDetails({
      ...artifactInfo,
      location,
      zoneId,
      sectionId,
      zoneName,
      sectionName,
    });
    setIsAddArtifactVisible(true);
    dispatch(templateActions.getDatingConventionList());
    dispatch(templateActions.getMileStoneList());
  };

  const deleteHandler = (event, info) => {
    event.stopPropagation();
    let requestPayload = {};
    const { origid, recentModifiedOn, lastmodifiedon } = info;
    switch (origid.split(".").length) {
      case 2:
        requestPayload = {
          artifactId: "",
          lastModifiedOn:
            recentModifiedOn ||
            lastmodifiedon ||
            tmfStructureData.lastmodifiedon,
          sectionId: origid,
          zoneId: origid.split(".")[0],
        };
        break;
      case 3:
        requestPayload = {
          artifactId: origid,
          lastModifiedOn:
            recentModifiedOn ||
            lastmodifiedon ||
            tmfStructureData.lastmodifiedon,
          sectionId: origid.split(".").slice(0, -1).join("."),
          zoneId: origid.split(".")[0],
        };
        break;
      default:
        requestPayload = {
          artifactId: "",
          lastModifiedOn:
            recentModifiedOn ||
            lastmodifiedon ||
            tmfStructureData.lastmodifiedon,
          sectionId: "",
          zoneId: origid,
        };
        break;
    }
    dispatch(templateActions.deleteStructure(requestPayload));
  };

  const renderTmfStructureArtifactButtons = (zone, item) => {
    return status === APP_CONST.ADMIN_TEMPLATE_STATUS[2] && isAdminReadOnly ? (
      !item.isdeleted && isAdminReadOnly && (
        <div className=" d-flex gap-6">
          <ViedocButtonElement
            size="small"
            variant="info"
            title={t("ADMIN.TEXT_EDIT")}
            onClick={(e) => editArtifactHandler(e, item, zone)}
          >
            {t("ADMIN.TEXT_EDIT")}
          </ViedocButtonElement>
          {zone !== "artifact" && (
            <ViedocButtonElement
              size="small"
              variant="info"
              title={t("ADMIN.BUTTON_ADDNEWARTIFACT")}
              onClick={(e) => addArtifactHandler(e, item, zone)}
            >
              {t("ADMIN.BUTTON_ADDNEWARTIFACT")}
            </ViedocButtonElement>
          )}
          <ViedocButtonElement
            size="small"
            variant="secondary"
            title={t("TMF.BUTTON_DELETE")}
            onClick={(e) => deleteHandler(e, item)}
          >
            {isDeleteLoading ? (
              <viedoc-spinner size="small" class="delete-spinner" />
            ) : (
              t("TMF.BUTTON_DELETE")
            )}
          </ViedocButtonElement>
        </div>
      )
    ) : (
      <ViedocButtonElement
        size="small"
        variant="info"
        title={t("ADMIN.TEXT_VIEW")}
        onClick={(e) => viewArtifactHandler(e, item)}
      >
        {t("ADMIN.TEXT_VIEW")}
      </ViedocButtonElement>
    );
  };

  const getIconStyle = (item) => {
    if (APP_CONST.FORM_CURRENT_ACTION_ID.includes(item.action))
      return "document-edit";
    if (item.origid === sectionId || item.origid === artifactId)
      return "document-dark";
    return "document-icon";
  };

  const sectionsArtifacts = (item, zone, iconStatus) =>
    item?.name?.toLowerCase() !== "not classified" && (
      <div
        key={item.id}
        className="row-hover f14 d-flex align-center pl-20 pt-10 pb-10 bb-1"
        onClick={() => {
          levelClick(item, zone);
        }}
      >
        <div
          className="row-hover f14 d-flex align-center"
          style={{
            marginLeft: zone === "artifact" ? 40 : zone === "section" ? 20 : 0,
          }}
        >
          <viedoc-icon
            class={getIconStyle(item)}
            name={selectIcons(iconStatus ? zone : "", item.name)}
            title={`${item.origid} ${item.name}`}
          />
          <p
            className={
              item.isdeleted
                ? "pl-7 lh-1 pr-8 lh1 sem-pri-color ff-mg line-through"
                : "pl-7 lh-1 pr-8 lh1 sem-pri-color ff-mg"
            }
            title={`${item.origid} ${item.name}`}
          >
            {settings.showstructurenumber
              ? `${item.origid} ${item.name}`
              : item.name}
          </p>
          {!(isEditLoading || isChangeLoading) &&
            renderTmfStructureArtifactButtons(zone, item)}
        </div>
      </div>
    );

  const newStructureElementHandler = () => {
    dispatch(templateActions.getDatingConventionList());
    dispatch(templateActions.getMileStoneList());
    setIsNewStructureElementVisible(true);
  };

  const exportTemplateHandler = (templateCategory) => {
    dispatch(
      templateActions.exportTemplate(
        originaltemplateid,
        templateCategory,
        isChecked
          ? structureversion ||
              UtilsHelper.fileExtensionRemoval(templatename || "")
          : UtilsHelper.fileExtensionRemoval(templatename || "")
      )
    );
  };

  const renderZoneData = () => {
    return (
      <article>
        {zoneData.map((item) => (
          <Fragment key={item.id}>
            {sectionsArtifacts(item, "zones", item["name"] === sections)}
            {item["name"] === sections &&
              item.sections.map((sectionItem) => (
                <Fragment key={sectionItem.id}>
                  {sectionsArtifacts(
                    sectionItem,
                    "section",
                    sectionItem["name"] === artifacts
                  )}
                  {sectionItem["name"] === artifacts &&
                    sectionItem.artifacts.map((art) =>
                      sectionsArtifacts(art, "artifact", true)
                    )}
                </Fragment>
              ))}
          </Fragment>
        ))}
        {isChecked && isAdminReadOnly && (
          <div
            className="row-hover f14 d-flex align-center pl-20 pt-10 pb-10 bb-1"
            onClick={(e) => newStructureElementHandler(e)}
          >
            <div className="row-hover f14 d-flex align-center ml-0">
              <viedoc-icon
                class="document-icon"
                name={selectIcons("artifact")}
              />
              <p
                className="pl-7 lh-1 pr-8 lh1 sem-pri-color ff-mg"
                title={`+ ${t("ADMIN.BUTTON_ADDNEWARTIFACT")}`}
              >
                {`+ ${t("ADMIN.BUTTON_ADDNEWARTIFACT")}`}
              </p>
            </div>
          </div>
        )}
      </article>
    );
  };

  const viewArtifactHandler = (event, item) => {
    event.stopPropagation();
    const { origid, sections, artifacts } = item;
    if (_.isEmpty(sections) && _.isEmpty(artifacts)) {
      dispatch(templateActions.getMilestoneToggleView(origid));
      setViewArtifactObj(true);
    } else {
      setIsEditZoneSectionVisible(true);
      setArtifactDetails({
        ...artifactDetails,
        ...item,
        location: !_.isEmpty(sections) ? "zones" : "section",
      });
      setZoneSectionView(isChecked && isAdminReadOnly ? "edit" : "view");
    }
  };

  const viewMilestoneHandler = () => {
    setViewMilestone(true);
    dispatch(templateActions.getMilestoneInfoList());
  };

  return templateInitializing ? (
    <PlaceholderComponent
      title={t("ADMIN.ADMINTAB_SETTINGUPETMF")}
      subTitle={t("ADMIN.ADMINTAB_COMEBACKSOON")}
      topSpinner
    />
  ) : isLoading || isZoneLoading || selectedLoading ? (
    <div className="overview-page-loader">
      <Loader />
    </div>
  ) : (
    <>
      {viewMilestone && (
        <MilestoneViewDialog
          type={isChecked && isAdminReadOnly ? "edit" : "view"}
          setViewMilestone={setViewMilestone}
        />
      )}
      {isEditZoneSectionVisible && (
        <EditZoneSection
          setIsEditZoneSectionVisible={setIsEditZoneSectionVisible}
          artifactDetails={artifactDetails}
          view={zoneSectionView}
        />
      )}
      {isEditArtifactVisible && (
        <EditArtifactPopUp
          artifactDetails={artifactDetails}
          setIsEditArtifactVisible={setIsEditArtifactVisible}
        />
      )}
      {isAddArtifactVisible && (
        <AddArtifactPopUp
          artifactDetails={artifactDetails}
          setIsAddArtifactVisible={setIsAddArtifactVisible}
        />
      )}
      {isNewStructureElementVisible && (
        <AddStructureElementPopUp
          setIsNewStructureElementVisible={setIsNewStructureElementVisible}
        />
      )}
      {isApplyRevertVisible && (
        <StructureChanges
          setApplyRevertVisible={setApplyRevertVisible}
          setIsChecked={setIsChecked}
          isApply={fromApplyOrRevert}
        />
      )}
      {isStructureEditVisible && (
        <EditStructure setIsStructureEditVisible={setIsStructureEditVisible} />
      )}

      <div className="Tmf-structure">
        <header className="header-padding bb-2">
          <h3>{t("ADMIN.ADMINTAB_TMFSTRUCTURE")}</h3>
        </header>

        {status === APP_CONST.ADMIN_TEMPLATE_STATUS[0]
          ? renderInstantiationBlock()
          : renderMaintenanceBlock()}

        {renderMilestonesBadge()}

        {viewArtifactObj && (
          <ViewArtifactDialog setViewArtifactObj={setViewArtifactObj} />
        )}

        <section className="structure-order">
          {renderTMFStuctureHeader()}

          {renderZoneData()}
        </section>
      </div>
      {
        <div className="f14 d-flex align-center pl-20 pt-10 pb-10 bb-1">
          <ViedocButtonElement
            size="small"
            variant="secondary"
            class="export-btn"
            title={t("TMF.BUTTON_EXPORTSTRUCTURE")}
            onClick={(e) => exportTemplateHandler("TMF Export")}
          >
            {isExporting ? <viedoc-spinner /> : t("TMF.BUTTON_EXPORTSTRUCTURE")}
          </ViedocButtonElement>
        </div>
      }
    </>
  );
};

export default TmfStructure;
